import { ETCLayerName } from "./ETCLayerName";
/**
 * ETCレイヤ種別定義
 */
type ETCLayerType = "ETC_DRM区間" | "ETC_交通調査基本区間";

/**
 * 道路種別定義
 */
type RoadType = "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "0";

/**
 * ETC_DRM区間_月レイヤ名
 */
const LAYER_ETC_PROBE_DRM_LNK_1M = "t_etc_probe_drm_lnk_1m";

/**
 * ETC_交通調査基本区間_月レイヤ名
 */
const LAYER_ETC_TRAFFIC_1M = "t_etc_probe_traffic_1m";

/**
 * ETC平休日定義
 */
export type DayType = "1" | "2" | "3";

export class ETCLayerNameMonth extends ETCLayerName {
  /**
   * 平休日区分
   */
  dayType: DayType;

  /**
   * コンストラクタ
   * @param etcLayerType ETCレイヤ種別
   * @param roadType 道路種別
   * @param dayType 平休日区分
   * @param timeCode 時間コード
   */
  constructor(
    etcLayerType: ETCLayerType,
    roadType: RoadType,
    dayType: DayType,
    timeCode: string
  ) {
    super(etcLayerType, roadType, timeCode);
    this.dayType = dayType;
  }

  /**
   * フィルタ条件文字列を取得
   */
  getCqlFilterString(): string {
    const cqlParameterString = `"道路種別コード"='${this.roadType}' AND "休平日区分"=${this.dayType} AND "時間コード"=${this.timeCode}`;
    return cqlParameterString;
  }

  /**
   * レイヤ名を取得
   */
  getLayerName(): string {
    let layerName = "";
    if (this.etcLayerType === "ETC_DRM区間") {
      layerName = LAYER_ETC_PROBE_DRM_LNK_1M;
    } else if (this.etcLayerType === "ETC_交通調査基本区間") {
      layerName = LAYER_ETC_TRAFFIC_1M;
    }
    return layerName;
  }
}
